import React from 'react';

/*
 * Compact LINEAR route map for the premium cockpit (dark theme).
 * A single straight road from START to Cottage 837; the excavator icon
 * travels horizontally with `progress` (0..1). Small footprint, no scroll.
 */
export const MiniMap = ({ progress = 0, milestones = [] }) => {
  const W = 340;
  const H = 78;
  const x0 = 24;
  const x1 = 316;
  const y = 44;
  const span = x1 - x0;

  const p = Math.max(0, Math.min(1, progress));
  const excX = x0 + p * span;

  return (
    <div className="glass-2 rounded-2xl px-3 py-2.5 relative" data-testid="minimap-route">
      <div className="flex items-center justify-between mb-1">
        <span className="font-display tracking-[0.2em] text-sm text-white/70">ROUTE</span>
        <span className="font-mono-tel text-[11px] px-2 py-0.5 rounded-full bg-[hsl(var(--hazard-yellow))] text-[#0e1217] font-semibold">
          {Math.round(p * 100)}%
        </span>
      </div>

      <svg width="100%" viewBox={`0 0 ${W} ${H}`} className="block">
        {/* milestone flags above the road */}
        {milestones.map((m, i) => {
          if (m.at >= 0.999) return null;
          const mx = x0 + m.at * span;
          const reached = p >= m.at - 0.001;
          return (
            <g key={`flag-${i}`}>
              <line x1={mx} y1={y - 18} x2={mx} y2={y} stroke={reached ? 'hsl(var(--hazard-yellow))' : 'rgba(255,255,255,0.25)'} strokeWidth="2" />
              <circle cx={mx} cy={y - 21} r="6" fill={reached ? 'hsl(var(--orange))' : '#20262e'} stroke={reached ? 'hsl(var(--hazard-yellow))' : 'rgba(255,255,255,0.3)'} strokeWidth="2" />
            </g>
          );
        })}

        {/* road edge */}
        <line x1={x0} y1={y} x2={x1} y2={y} stroke="rgba(255,255,255,0.12)" strokeWidth="16" strokeLinecap="round" />
        {/* road surface */}
        <line x1={x0} y1={y} x2={x1} y2={y} stroke="#0c0f13" strokeWidth="11" strokeLinecap="round" />
        {/* center dashes */}
        <line x1={x0} y1={y} x2={x1} y2={y} stroke="rgba(255,255,255,0.55)" strokeWidth="1.5" strokeDasharray="7 7" />
        {/* travelled */}
        <line x1={x0} y1={y} x2={excX} y2={y} stroke="hsl(var(--hazard-yellow))" strokeWidth="3.5" strokeLinecap="round" style={{ transition: 'all 0.1s linear' }} />

        {/* START */}
        <circle cx={x0} cy={y} r="6" fill="#22C55E" stroke="#0e1217" strokeWidth="2" />
        {/* DEST */}
        <circle cx={x1} cy={y} r="8" fill={p >= 0.999 ? 'hsl(var(--orange))' : '#20262e'} stroke="hsl(var(--hazard-yellow))" strokeWidth="2.2" />
        <circle cx={x1} cy={y} r="2.6" fill="#fff" />

        {/* excavator */}
        <g transform={`translate(${excX}, ${y})`} style={{ transition: 'transform 0.1s linear' }}>
          <circle r="13" fill="hsl(var(--hazard-yellow))" stroke="#0e1217" strokeWidth="2.2" />
          <g transform="translate(-8,-7) scale(0.68)" fill="#0e1217">
            <rect x="2" y="12" width="20" height="7" rx="2" />
            <rect x="5" y="7" width="9" height="6" rx="1" />
            <line x1="13" y1="9" x2="24" y2="3" stroke="#0e1217" strokeWidth="2" />
            <path d="M22 2 l5 2 l-2 4 z" />
            <circle cx="7" cy="20" r="3" />
            <circle cx="17" cy="20" r="3" />
          </g>
        </g>

        {/* labels */}
        <text x={x0} y={y + 22} fontSize="8.5" textAnchor="middle" fill="rgba(255,255,255,0.45)" fontFamily="'IBM Plex Mono', monospace">START</text>
        <text x={x1} y={y + 22} fontSize="8.5" textAnchor="middle" fill="rgba(255,255,255,0.45)" fontFamily="'IBM Plex Mono', monospace">837</text>
      </svg>
    </div>
  );
};
